import CompetitorCard from './CompetitorCard';

export default CompetitorCard;
